import { STEPS } from "../../data/site";
import { Reveal } from "./Reveal";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative border-y border-white/10 bg-[#1E9BFF] py-24 text-black md:py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-black/70">
          <span>03</span><span className="h-px w-10 bg-black/60" /><span>How It Works</span>
        </div>
        <h2 className="mt-5 font-display text-4xl font-extrabold uppercase leading-none sm:text-5xl">Three Steps. Zero Hassle.</h2>
      </Reveal>
      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-0">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 120}>
            <div data-testid={`process-step-${i + 1}`} className={`relative md:px-8 ${i > 0 ? "md:border-l md:border-black/20" : "md:pl-0"}`}>
              <div className="font-display text-7xl font-extrabold leading-none text-black/20">0{i + 1}</div>
              <h3 className="mt-4 font-display text-2xl font-bold uppercase">{s.title}</h3>
              <p className="mt-3 max-w-xs text-sm text-black/75">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

